import { collectionApi, CollectionApi } from './collection';

export { collectionApi, CollectionApi };



// WEBPACK FOOTER //
// ./src/api/collection/index.ts